import {
    SET_CURRENT_USER,
    AUTH_LOADING,
    GET_ERRORS,
    CLEAR_ERRORS,
    DRAWER_TOGGLE
} from "./types";
import axios from "axios";
import setAuthToken from "../utlis/setAuthToken";
import jwt_decode from "jwt-decode";

export const registerUser = (userData, history) => (dispatch) => {
    dispatch(setAuthLoading());

    axios
        .post(`/api/users/register`, userData)
        .then((res) => {
            dispatch(setAuthLoading());
            history.push("/login");
            console.log(res.data, "regi");
        })
        .catch((err) => {
            dispatch({
                type: GET_ERRORS,
                payload: err.response.data,
            });
            console.log(err, "regi");
            dispatch(setAuthLoading());
        });
};

//login - Get User Token
export const loginUser = (userData) => (dispatch) => {
    dispatch(setAuthLoading());
    axios
        .post("/api/users/login", userData)
        .then((res) => {
            // save to localStorage
            const { token } = res.data;
            //set token to local storage
            localStorage.setItem("jwtToken", token);
            //set token to Auth header
            setAuthToken(token);
            //Decode token to get user data
            const decoded = jwt_decode(token);
            //set current user
            dispatch(setCurrentUser(decoded));
            window.location.href = "/";
        })
        .catch((err) => {
            dispatch({
                type: GET_ERRORS,
                payload: err.response.data,
            });
            console.log(err);
            dispatch(setAuthLoading());
        });
};

export const changePassword = (
    userData,
    setsuccess,
    setStateErros,
    history
) => (dispatch) => {
    dispatch(setAuthLoading());
    axios
        .post("/api/users/update/password", userData)
        .then((res) => {
            setsuccess(true);
            setStateErros({});
            dispatch(setAuthLoading());
            history.push("/");
        })
        .catch((err) => {
            // dispatch({
            //     type: GET_ERRORS,
            //     payload: err.response.data,
            // });
            console.log(err.response.data);
            dispatch(setAuthLoading());
        });
};

// set Logged in user
export const setCurrentUser = (decoded) => {
    return {
        type: SET_CURRENT_USER,
        payload: decoded,
    };
};

// log user out

export const logoutUser = (history) => (dispatch) => {
    //remove token from localstorage
    localStorage.removeItem("jwtToken");
    //remove auth header for future request
    setAuthToken(false);
    //set current user to {} which will also set  isAuthenticated to false
    dispatch(setCurrentUser({}));
    // history.push("/");
    // console.log(history);
    window.location.pathname = "/";
};

export const setAuthLoading = () => {
    return {
        type: AUTH_LOADING,
    };
};

export const toogleDrawer = () => {
    return {
        type: DRAWER_TOGGLE
    }
}

export const clearErrors = () => {
    return {
        type: CLEAR_ERRORS,
    };
};
